import { render, staticRenderFns } from "./permittings-table.vue?vue&type=template&id=aa41e5c2&scoped=true"
import script from "./permittings-table.vue?vue&type=script&lang=js"
export * from "./permittings-table.vue?vue&type=script&lang=js"
import style0 from "./permittings-table.vue?vue&type=style&index=0&id=aa41e5c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa41e5c2",
  null
  
)

export default component.exports